import React from "react";

import "./Details.scss";

const Details = ({ items }) => (
  <div className="details">
    <div className="details__items">
      {items.map(
        (item, x) =>
          item !== undefined &&
          item !== null &&
          item !== false &&
          item !== "" && (
            <div key={x} className="details__item">
              {item}
            </div>
          )
      )}
    </div>
  </div>
);

export default Details;
